import { useCallback, useEffect, useState } from 'react';
import { ProjectsApi, type ProjectListItem } from './api';
import { makeSyncController } from './syncController';
import { applyDocJson } from '../persistence/local-store';
import { currentAccessToken } from '../auth/useAuth';
import { proxyHttpBase } from '../agent/config';

const api = new ProjectsApi(proxyHttpBase(), async () => currentAccessToken() ?? '');

export const syncController = makeSyncController({ api, loadDoc: applyDocJson });

export function useProjectList(): { projects: ProjectListItem[]; refresh: () => Promise<void>; loading: boolean } {
  const [projects, setProjects] = useState<ProjectListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const refresh = useCallback(async () => {
    setLoading(true);
    try { setProjects(await api.list()); }
    catch (err) { console.warn('[codeframe] failed to list projects', err); setProjects([]); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { void refresh(); }, [refresh]);
  return { projects, refresh, loading };
}

export { api as projectsApi };
